module.exports = __webpack_public_path__ + "static/media/heart-circle.add93ffa.svg";